module.exports = __webpack_public_path__ + "static/media/S (33).976ed9c1.jpg";